import { render, staticRenderFns } from "./TaskAssigneeSelector.vue?vue&type=template&id=4fb1a16c&"
import script from "./TaskAssigneeSelector.vue?vue&type=script&lang=js&"
export * from "./TaskAssigneeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
